module.exports={render:function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "hello"
  }, [_vm._h('vue-progress-bar', {
    attrs: {
      "show": true,
      "reference": "example"
    }
  }), " ", _vm._h('table', {
    attrs: {
      "id": "links-list"
    }
  }, [_vm._h('tr', [_vm._h('td', {
    staticClass: "container primary"
  }, [_vm._h('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.start('example')
      }
    }
  }, ["Start"])]), " ", _vm._h('td', {
    staticClass: "container secondary"
  }, [_vm._h('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.finish('example')
      }
    }
  }, ["Finish"])]), " ", _vm._h('td', {
    staticClass: "container danger"
  }, [_vm._h('div', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.fail('example')
      }
    }
  }, ["Fail"])])]), " ", _vm._h('tr', [_vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trail.use),
      expression: "trail.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.trail.use) ? _vm._i(_vm.trail.use, null) > -1 : _vm._q(_vm.trail.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.trail.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.trail.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.trail.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.trail.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.trail.use = !_vm.trail.use
      }
    }
  }, [_vm._s(_vm.checkboxes.trail), _vm._m(0)]), " ", (_vm.trail.use) ? _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.trail.data),
      expression: "trail.data"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "100",
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.trail.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.trail.data = _vm._n($event.target.value)
      }
    }
  }) : _vm._e(), " "]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.use),
      expression: "thickness.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.thickness.use) ? _vm._i(_vm.thickness.use, null) > -1 : _vm._q(_vm.thickness.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.thickness.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.thickness.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.thickness.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.thickness.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.thickness.use = !_vm.thickness.use
      }
    }
  }, [_vm._s(_vm.checkboxes.thickness), _vm._m(1)]), " ", (_vm.thickness.use) ? _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.thickness.data),
      expression: "thickness.data"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "10",
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.thickness.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.thickness.data = _vm._n($event.target.value)
      }
    }
  }) : _vm._e(), " "]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color.use),
      expression: "color.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.color.use) ? _vm._i(_vm.color.use, null) > -1 : _vm._q(_vm.color.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.color.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.color.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.color.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.color.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.color.use = !_vm.color.use
      }
    }
  }, [_vm._s(_vm.checkboxes.sColor), _vm._m(2)]), " ", (_vm.color.use) ? _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color.data),
      expression: "color.data"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "#00A1FF",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.color.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.color.data = $event.target.value
      }
    }
  }) : _vm._e(), " "])]), " ", _vm._h('tr', [_vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradient.use),
      expression: "gradient.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.gradient.use) ? _vm._i(_vm.gradient.use, null) > -1 : _vm._q(_vm.gradient.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gradient.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.gradient.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.gradient.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.gradient.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.gradient.use = !_vm.gradient.use
      }
    }
  }, [_vm._s(_vm.checkboxes.gradient), _vm._m(3)]), " ", (_vm.gradient.use) ? _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gradient.data),
      expression: "gradient.data"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "predefined",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.gradient.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.gradient.data = $event.target.value
      }
    }
  }) : _vm._e(), " "]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.failColor.use),
      expression: "failColor.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.failColor.use) ? _vm._i(_vm.failColor.use, null) > -1 : _vm._q(_vm.failColor.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.failColor.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.failColor.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.failColor.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.failColor.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.failColor.use = !_vm.failColor.use
      }
    }
  }, [_vm._s(_vm.checkboxes.fColor), _vm._m(4)]), " ", (_vm.failColor.use) ? _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.failColor.data),
      expression: "failColor.data"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "red",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.failColor.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.failColor.data = $event.target.value
      }
    }
  }) : _vm._e(), " "]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transition.use),
      expression: "transition.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.transition.use) ? _vm._i(_vm.transition.use, null) > -1 : _vm._q(_vm.transition.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.transition.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.transition.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.transition.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.transition.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.transition.use = !_vm.transition.use
      }
    }
  }, [_vm._s(_vm.checkboxes.transition)]), " ", (_vm.transition.use) ? _vm._h('span', {
    staticClass: "text"
  }, [_vm._m(5), "Time ", _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transition.time),
      expression: "transition.time"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "2",
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.transition.time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.transition.time = _vm._n($event.target.value)
      }
    }
  })]) : _vm._e(), " ", (_vm.transition.use) ? _vm._h('span', {
    staticClass: "text"
  }, [_vm._m(6), "Opacity ", _vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.transition.opacity),
      expression: "transition.opacity"
    }],
    staticClass: "data",
    attrs: {
      "placeholder": "2",
      "type": "number"
    },
    domProps: {
      "value": _vm._s(_vm.transition.opacity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.transition.opacity = _vm._n($event.target.value)
      }
    }
  })]) : _vm._e(), " "])]), " ", _vm._h('tr', [_vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.locations.location),
      expression: "locations.location"
    }],
    staticClass: "text",
    on: {
      "change": function($event) {
        _vm.locations.location = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_vm._m(7), " ", _vm._m(8), " ", _vm._m(9), " ", _vm._m(10)])]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bounce.use),
      expression: "bounce.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.bounce.use) ? _vm._i(_vm.bounce.use, null) > -1 : _vm._q(_vm.bounce.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.bounce.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.bounce.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.bounce.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.bounce.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.bounce.use = !_vm.bounce.use
      }
    }
  }, [_vm._s(_vm.checkboxes.bounce)]), " "]), " ", _vm._h('td', {
    staticClass: "container default"
  }, [_vm._h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inverse.use),
      expression: "inverse.use"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.inverse.use) ? _vm._i(_vm.inverse.use, null) > -1 : _vm._q(_vm.inverse.use, true)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.inverse.use,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.inverse.use = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.inverse.use = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.inverse.use = $$c
        }
      }
    }
  }), _vm._h('span', {
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.inverse.use = !_vm.inverse.use
      }
    }
  }, [_vm._s(_vm.checkboxes.inverse)]), " "])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('br')
},function (){var _vm=this;
  return _vm._h('option', {
    attrs: {
      "value": "top"
    }
  }, ["Top"])
},function (){var _vm=this;
  return _vm._h('option', {
    attrs: {
      "value": "bottom"
    }
  }, ["Bottom"])
},function (){var _vm=this;
  return _vm._h('option', {
    attrs: {
      "value": "left"
    }
  }, ["Left"])
},function (){var _vm=this;
  return _vm._h('option', {
    attrs: {
      "value": "right"
    }
  }, ["Right"])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2079b4f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 67
// module chunks = 2